var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-search__search-area" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", { staticClass: "result-count" }, [
          _vm._v(
            _vm._s(_vm.totalResults) +
              " " +
              _vm._s(_vm.localization.labels.results)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-md-4" },
        [
          _c("div", { staticClass: "form__input--with-icon" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { maxlength: "100", type: "text" },
              domProps: { value: _vm.keyword },
              on: {
                focus: function ($event) {
                  _vm.showSuggestions = true
                },
                blur: function ($event) {
                  _vm.showSuggestions = false
                },
                keyup: (e) => {
                  _vm.onKeyUp(e)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.keyword = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "input__label input__icon",
                on: { click: _vm.search },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "17px",
                      height: "17px",
                      viewBox: "0 0 17 17",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    },
                  },
                  [
                    _c("defs", [
                      _c("rect", {
                        attrs: { x: "0", y: "0", width: "398", height: "40" },
                      }),
                      _c(
                        "filter",
                        {
                          attrs: {
                            x: "-0.8%",
                            y: "-7.5%",
                            width: "101.5%",
                            height: "115.0%",
                            filterUnits: "objectBoundingBox",
                          },
                        },
                        [
                          _c("feGaussianBlur", {
                            attrs: {
                              stdDeviation: "1.5",
                              in: "SourceAlpha",
                              result: "shadowBlurInner1",
                            },
                          }),
                          _c("feOffset", {
                            attrs: {
                              dx: "3",
                              dy: "3",
                              in: "shadowBlurInner1",
                              result: "shadowOffsetInner1",
                            },
                          }),
                          _c("feComposite", {
                            attrs: {
                              in: "shadowOffsetInner1",
                              in2: "SourceAlpha",
                              operator: "arithmetic",
                              k2: "-1",
                              k3: "1",
                              result: "shadowInnerInner1",
                            },
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              values:
                                "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.03 0",
                              type: "matrix",
                              in: "shadowInnerInner1",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "g",
                      {
                        attrs: {
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              transform: "translate(-379.000000, -220.000000)",
                              "fill-rule": "nonzero",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  transform: "translate(8.000000, 178.000000)",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(0.000000, 31.000000)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("use", {
                                        attrs: {
                                          fill: "#EFECEB",
                                          "xlink:href": "#path-1",
                                        },
                                      }),
                                      _c("use", {
                                        attrs: {
                                          fill: "black",
                                          "fill-opacity": "1",
                                          filter: "url(#filter-2)",
                                          "xlink:href": "#path-1",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      attrs: {
                                        d: "M385.996833,28 L380.764375,22.7675417 C379.781208,23.386625 378.622375,23.75 377.375,23.75 C373.853875,23.75 371,20.896125 371,17.375 C371,13.853875 373.853875,11 377.375,11 C380.896125,11 383.75,13.853875 383.75,17.375 C383.75,18.622375 383.385917,19.7819167 382.767542,20.764375 L388,25.9968333 L385.996833,28 Z M377.375,22.3333333 C380.108458,22.3333333 382.333333,20.1091667 382.333333,17.375 C382.333333,14.6408333 380.108458,12.4166667 377.375,12.4166667 C374.641542,12.4166667 372.416667,14.6408333 372.416667,17.375 C372.416667,20.1091667 374.641542,22.3333333 377.375,22.3333333 Z",
                                        fill: "#000000",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.showSuggestions
            ? [
                _c(
                  "ul",
                  { staticClass: "suggestions filter--list" },
                  [
                    _vm._l(_vm.suggestions, function (suggestion, index) {
                      return [
                        _c(
                          "li",
                          {
                            class: [
                              "suggestion",
                              _vm.selectedSuggestion === index ? "active" : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.setKeyword(index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(suggestion))]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col button-container" }, [
        _c(
          "button",
          { staticClass: "button button--primary", on: { click: _vm.search } },
          [_vm._v(_vm._s(_vm.localization.buttons.search))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }